import _styled from "styled-components";
var _excluded = ["alt", "css", "height", "loading", "onError", "onLoad", "src", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef, useState } from 'react';
import * as styles from "./Image.styles";

/**
 * `Image` is used to render images that show a placeholder while they are loading, and provides a fallback for
 * lazy loading if the browser does not support it natively.
 *
 * `Image` is an **enhanced native element** component. That is, unlike other Ribbons components, where consumers should remain
 * agnostic about the HTML they render, with `Image`, consumers can rely on it to render an `<img />` element. As such it
 * supports all the props that a native `<img />` element supports.
 */
export var Image = function Image(_ref) {
  var alt = _ref.alt,
    css = _ref.css,
    height = _ref.height,
    loading = _ref.loading,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    src = _ref.src,
    width = _ref.width,
    restOfImgProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showPlaceholder = _useState2[0],
    setShowPlaceholder = _useState2[1];
  var imgRef = useRef(null);
  var onImageError = function onImageError() {
    setShowPlaceholder(false);
    onError === null || onError === void 0 || onError();
  };
  var onImageLoad = function onImageLoad() {
    setShowPlaceholder(false);
    onLoad === null || onLoad === void 0 || onLoad();
  };
  useEffect(function () {
    var _imgRef$current;
    // If the image is already loaded (cached images), we need to trigger the onLoad event manually
    if ((_imgRef$current = imgRef.current) !== null && _imgRef$current !== void 0 && _imgRef$current.complete) {
      onImageLoad();
    }
  }, [src]);
  return /*#__PURE__*/React.createElement(_StyledImg, _extends({}, restOfImgProps, {
    alt: alt,
    height: height,
    loading: loading,
    onError: onImageError,
    onLoad: onImageLoad,
    ref: imgRef,
    src: src,
    width: width,
    $_css: [showPlaceholder && styles.imagePlaceholder, css]
  }));
};
var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "Image___StyledImg",
  componentId: "sc-nztypg-0"
})(["", ""], function (p) {
  return p.$_css;
});